import { createStore, applyMiddleware, Middleware } from "redux";
import { middleware as reduxPackMiddleware } from "redux-pack";
import { thunk } from "redux-thunk";
import appReducers from "./reducers/main";
import { composeWithDevTools } from "redux-devtools-extension";
import bundleUpdateMiddleware from "./middleware/bundle-update-middleware";

const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25 });
export let testStore: any;

const store = createStore(
	appReducers,
	composeEnhancers(applyMiddleware(thunk, reduxPackMiddleware as Middleware, bundleUpdateMiddleware))
);

if (import.meta.env.MODE === 'test') {
	testStore = (testData: any) => {
		return createStore(appReducers,
			{ ...composeWithDevTools(applyMiddleware(thunk, reduxPackMiddleware as Middleware)), ...testData });
	};
}

export default store;
